import React from 'react';
import { getDeviationType } from '../_helpers';
import { DeviationTypes } from '../../types/deviation';
import CommissionDetails from './Commission';
import PollDetails from './Poll';
import StatusDetails from './Status';
import JournalDetails from './Journal';
import LiteratureDetails from './Literature';
import TierDetails from './Tier';
import DefaultDetails from './Default';
export const Details = (props)=>{
    const deviationType = getDeviationType(props.deviation);
    switch(deviationType){
        case DeviationTypes.COMMISSION:
            return /*#__PURE__*/ React.createElement(CommissionDetails, props);
        case DeviationTypes.POLL:
            return /*#__PURE__*/ React.createElement(PollDetails, props);
        case DeviationTypes.STATUS:
            return /*#__PURE__*/ React.createElement(StatusDetails, props);
        case DeviationTypes.JOURNAL:
            return /*#__PURE__*/ React.createElement(JournalDetails, props);
        case DeviationTypes.LITERATURE:
            return /*#__PURE__*/ React.createElement(LiteratureDetails, props);
        case DeviationTypes.TIER:
            return /*#__PURE__*/ React.createElement(TierDetails, props);
        default:
            return /*#__PURE__*/ React.createElement(DefaultDetails, props);
    }
};
Details.displayName = 'Details';
export default Details;

//# sourceMappingURL=Details.js.map